import React, { Fragment, useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Skeleton,
  TextField,
} from "@mui/material";
import { Tabs, Tab, InputAdornment } from "@mui/material";
import { Card, Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import { toast } from "react-toastify";
import { isEmpty } from "lodash";
import { createNewVideo, fetchVideoById, updateVideo } from "../actions/video";
import SubmitButtonForm from "../components/Admin/Reusable/Form/SubmitButtonForm";
import FormTitleMain from "../components/Admin/Reusable/FormTitleMain";
import InputField from "../components/Admin/Reusable/InputField";
import UploadImage from "../components/Admin/Reusable/UploadImage";
import languagesItems from "../utils/languages";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import { Editor } from "ckeditor5-custom-build/build/ckeditor";

import { TabPanel, a11yProps } from "../helper/TabPanel";
import SelectStatus from "../components/Admin/Reusable/Form/SelectStatus";

import AlertBox from "../components/Admin/Reusable/AlertBox";
import { useSelector } from "react-redux";
import {
  basicFormValidationHandler,
  formatOnlyDateDB,
  validateLocalesFields,
} from "../utils";
import { fetchChannelFormList } from "../actions/channel";
import {
  fetchCourseFormList,
  fetchCourseFormListClear,
} from "../actions/course";
import { appendIfFile } from "../helper/FileCheck";
import { fetchCategoryFormList } from "../actions/category";
import TagAutocomplete from "../components/Admin/Reusable/TagAutocomplete";
import { fetchTagFormList } from "../actions/tag";
import AmountInputField from "../components/Admin/Reusable/AmountInputField";
import { videoActions } from "../reducers/video";
import GlobalProgressOverlay from "../components/Admin/Reusable/GlobalProgressOverlay";

const VideoAdd = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams();

  const [activeLocaleTab, setActiveLocaleTab] = useState(0);
  const handleChangeLocaleTab = (e, newValue) => setActiveLocaleTab(newValue);
  const [errors, setErrors] = useState({});
  const { videoDetail, loading, success, actionType } = useSelector(
    (state) => state.videoReducer
  );
  const { channelFormList } = useSelector((state) => state.channelReducer);
  const { courseFormList } = useSelector((state) => state.courseReducer);
  const { categoryFormList, loading: loadingCategories } = useSelector(
    (state) => state.categoryReducer
  );
  const { tagFormList, loading: loadingTags } = useSelector(
    (state) => state.tagReducer
  );

  const categoryOptions = Array.isArray(categoryFormList)
    ? categoryFormList
    : [];
  const tagOptions = Array.isArray(tagFormList) ? tagFormList : [];

  //locales
  // const [locales, setLocales] = useState(() =>
  //   Object.fromEntries(
  //     languagesItems.map((l) => [
  //       l.code,
  //       { id: null, name: "", description: "", language: l.code },
  //     ])
  //   )
  // );

  const getInitialLocales = () =>
    Object.fromEntries(
      languagesItems.map((l) => [
        l.code,
        { id: null, name: "", description: "", language: l.code },
      ])
    );

  const [locales, setLocales] = useState(getInitialLocales);

  const initialState = {
    discountStart: "",
    discountPrice: "",
    price: "",
    discountEnd: "",
    sectionType: "MICRO",
    active: true,
    free: false,
    shoppable: true,
    discount: false,
    courseId: "",
    channelId: "",
    channelLinkId: null,
    tags: [],
    categories: [],
    coursePosition: 1,
    videoTargetId: "",
    // videoPlayerId: "",
    trailerTargetId: "",
    // trailerPlayerId: "",
    accessDuration: 30,
    position: 1,
    drm: false,
  };

  //osnovi podaci
  const [data, setData] = useState(initialState);
  const [progress, setProgress] = useState(0);
  const [showLoader, setShowLoader] = useState(false);

  const initialStateFiles = {
    image: null,
    // smallImage: null,
  };

  //fajlovi
  const [files, setFiles] = useState(initialStateFiles);
  const [channelValue, setChannelValue] = useState(0);

  //breadcrumbs
  const translateForm = "videoForm";
  const translateModule = "video";
  const pageType = id ? "Edit" : "Add";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const setFile = (key) => (file) =>
    setFiles((prev) => ({ ...prev, [key]: file }));

  useEffect(() => {
    dispatch(fetchChannelFormList());
    dispatch(fetchCategoryFormList());
    dispatch(fetchTagFormList());
    if (!id) {
      // Ako `id` ne postoji, očisti stanje za novu kreaciju
      setData(initialState);
      setFiles(initialStateFiles);
      setLocales(getInitialLocales());
    } else {
      // Ako `id` postoji, učitaj podatke za korisnika
      dispatch(fetchVideoById(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (videoDetail && id) {
      setData({
        ...videoDetail,
        discountEnd: formatOnlyDateDB(videoDetail?.discountEnd),
        discountStart: formatOnlyDateDB(videoDetail?.discountStart),
      });
      setFiles({
        image: videoDetail?.image,
        // smallImage: videoDetail?.smallImage,
      });

      // popuni locales iz backend-a
      const filledLocales = Object.fromEntries(
        languagesItems.map((l) => {
          const found = videoDetail.locales?.find(
            (loc) =>
              loc.language === l.code || loc.language === l.label.toUpperCase()
          );
          return [
            l.code,
            {
              id: found?.id || null,
              name: found?.name || "",
              description: found?.description || "",
              language: l.code,
            },
          ];
        })
      );
      if (videoDetail?.channelId)
        dispatch(fetchCourseFormList(videoDetail?.channelId));

      setLocales(filledLocales);
    }
  }, [videoDetail, id, dispatch]);

  useEffect(() => {
    let interval;
    let timeout;

    if (loading) {
      setShowLoader(true);
      setProgress(0);

      interval = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 100) {
            clearInterval(interval);
            return 100;
          }
          return prev + 5;
        });
      }, 100);
    } else if (!loading && showLoader) {
      setProgress(100);
      timeout = setTimeout(() => {
        setShowLoader(false);
        setProgress(0);
      }, 2000);
    }

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [loading]);

  useEffect(() => {
    if (success) {
      const timeout = setTimeout(() => {
        navigate("/video-list");

        if (actionType === "create") {
          toast.success("Uspešno ste kreirali novi video", {
            theme: "colored",
          });
        } else if (actionType === "update") {
          toast.success("Uspešno ste izmenili video", { theme: "colored" });
        }

        dispatch(videoActions.clearError());
      }, 2000);

      return () => clearTimeout(timeout);
    } else {
      dispatch(videoActions.clearError());
    }
  }, [success]);

  const userValidationHandler = () => {
    let errorsObject = {};

    // univerzalno obavezna polja
    errorsObject = {
      ...errorsObject,
      ...basicFormValidationHandler({
        trailerTargetId: data.trailerTargetId,
        videoTargetId: data.videoTargetId,
        // videoPlayerId: data.videoPlayerId,
        // trailerPlayerId: data.trailerPlayerId,
        categories: data.categories,
        tags: data.tags,
        // coursePosition: data.coursePosition,
      }),
    };

    if (data.shoppable == true) {
      errorsObject = {
        ...errorsObject,
        ...basicFormValidationHandler({
          accessDuration: data.accessDuration,
        }),
      };
    }

    // price je obavezan samo ako je shoppable === true
    if (data.shoppable) {
      errorsObject = {
        ...errorsObject,
        ...basicFormValidationHandler({
          price: data.price,
        }),
      };
    }

    // discount polja su obavezna samo ako je discount === true
    if (data.discount) {
      errorsObject = {
        ...errorsObject,
        ...basicFormValidationHandler({
          discountPrice: data.discountPrice,
          discountStart: data.discountStart,
        }),
      };
    }

    if (data.sectionType === "MASTER") {
      // courseId je uvek obavezan
      if (!data.coursePosition || data.coursePosition === 0) {
        errorsObject.coursePosition = "Obavezno polje";
      }
      // courseId je uvek obavezan
      if (!data.courseId || data.courseId === 0) {
        errorsObject.courseId = "Obavezno polje";
      }

      // channelId je uvek obavezan
      if (!data.channelId || data.channelId === 0) {
        errorsObject.channelId = "Obavezno polje";
      }
    }

    const localeErrors = validateLocalesFields(locales, [
      "name",
      "description",
    ]);
    if (Object.keys(localeErrors).length > 0) {
      errorsObject.locales = localeErrors;
    }

    setErrors(errorsObject);

    if (!isEmpty(errorsObject)) {
      toast.error("Morate popuniti sva obavezna polja!", {
        theme: "colored",
      });
    }

    return !isEmpty(errorsObject);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (userValidationHandler()) {
      return;
    }

    // ✅ 2. Provera da li je slika odabrana
    if (!files?.image) {
      toast.error("Morate odabrati sliku.", { theme: "colored" });
      return;
    }

    const formData = new FormData();

    // pretvaranje locales objekta u niz za backend
    const localesArray = Object.entries(locales).map(([code, v]) => ({
      ...v,
      // ako postoji id, prosledi; ako ne, backend može generisati
      id: v.id || undefined,
    }));

    const dataForm = {
      ...data,
      locales: localesArray,
      categories: (data.categories || []).map((c) => c.id),
      tags: (data.tags || []).map((c) => c.id),
    };

    if (id) {
      dataForm.id = id;
    }

    if (data.courseId == 0) {
      dataForm.courseId = "";
    }

    // Ukloni polja za popust po difoltu
    delete dataForm.discountPrice;
    delete dataForm.discountStart;
    delete dataForm.discountEnd;

    // Ako je popust aktivan, DODAJ ih
    if (data.discount) {
      if (data.discountPrice !== "") {
        dataForm.discountPrice = data.discountPrice;
      }
      if (data.discountStart) {
        const d1 = new Date(data.discountStart);
        if (!isNaN(d1)) dataForm.discountStart = d1.toISOString();
      }
      if (data.discountEnd) {
        const d2 = new Date(data.discountEnd);
        if (!isNaN(d2)) dataForm.discountEnd = d2.toISOString();
      }
    }

    formData.append(
      "video",
      new Blob([JSON.stringify(dataForm)], { type: "application/json" })
    );
    appendIfFile(formData, "image", files.image);
    // appendIfFile(formData, "smallImage", files.smallImage);

    if (id) {
      dispatch(updateVideo(formData, navigate, id));
    } else {
      dispatch(createNewVideo(formData, navigate));
    }
  };

  const handleSelectChange = (name, value) => {
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const updateLocale = (code, field, value) => {
    setLocales((prev) => ({
      ...prev,
      [code]: { ...prev[code], [field]: value },
    }));
  };

  const handleInputChange = (eOrName, maybeValue) => {
    if (typeof eOrName === "string") {
      const name = eOrName;
      const value = maybeValue;
      setData((prev) => ({ ...prev, [name]: value }));
      return;
    }

    const e = eOrName;
    const { name, type, value, checked } = e.target;

    setData((prev) => {
      // default ažuriranje
      let next = { ...prev, [name]: type === "checkbox" ? checked : value };

      // pravila za međusobno isključive checkboxe
      if (type === "checkbox") {
        if (name === "shoppable") {
          if (checked) {
            next.free = false;
          } else {
            // ako više NIJE shoppable i NIJE free → none
            if (!next.free) {
              next.price = "";
              next.discount = false;
              next.discountPrice = "";
            }
          }
        }

        if (name === "free") {
          if (checked) {
            next.shoppable = false;
            // free režim: očisti cene/popuste
            next.price = "";
            next.discount = false;
            next.discountPrice = "";
          } else {
            // ako više NIJE free i NIJE shoppable → none
            if (!next.shoppable) {
              next.price = "";
              next.discount = false;
              next.discountPrice = "";
            }
          }
        }

        if (name === "discount") {
          // popust sme samo uz shoppable
          if (!next.shoppable && checked) {
            next.discount = false;
          }
        }
      }

      return next;
    });
  };

  const setChannelChange = (e) => {
    setData((prev) => ({ ...prev, channelId: e.target.value }));
    if (e.target.value) {
      dispatch(fetchCourseFormList(e.target.value));
    } else {
      setData((prev) => ({ ...prev, courseId: 0 }));
      dispatch(fetchCourseFormListClear());
    }
  };

  return (
    <Fragment>
      <Breadcrumb
        breadcrumbItems={breadcrumbItems}
        type={`${translateModule}${pageType}`}
        id={id}
        pageType={pageType}
      />
      {showLoader && <GlobalProgressOverlay progress={progress} />}
      <Container className="video-container">
        <Row>
          <Col lg={12}>
            <form onSubmit={handleSubmit} noValidate>
              <Row>
                <Col lg={12}>
                  <div className="text-end mb-2">
                    <SubmitButtonForm formHanlder={handleSubmit} id={id} />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={9}>
                  <Row>
                    <Col lg={12}>
                      <Card>
                        <Card.Header>
                          <FormTitleMain />
                        </Card.Header>
                        <Card.Body>
                          <div className="blog-holder-admin-left-side-text">
                            <Row className="mb-2">
                              <Col>
                                <AlertBox
                                  title={
                                    "Ukoliko opcije 'Na prodaju' i 'Besplatno' nisu aktivne, korisnici se ne mogu direktno pretplatiti na ovaj video. Pristup videu će se automatski otključati ukoliko je korisnik pretplaćen na sve što hijerarhijski obuhvata ovaj sadržaj (kanal i/ili kurs kojem video pripada)."
                                  }
                                />
                              </Col>
                            </Row>
                            <Row className="mb-2">
                              <Col>
                                <SelectStatus
                                  shoppable={true}
                                  free={true}
                                  data={data}
                                  row={true}
                                  handleInputChange={handleInputChange}
                                />
                              </Col>
                            </Row>
                            <Row>
                              {data?.shoppable && (
                                <Col lg={4} md={12} xs={12} className="mb-4">
                                  <AmountInputField
                                    label={t(`${translateForm}.price`)}
                                    name="price"
                                    value={data.price}
                                    onChange={handleInputChange}
                                    error={errors}
                                    errorsHandler={setErrors}
                                    fullWidth
                                    size="small"
                                    required={data?.shoppable}
                                    inputProps={{
                                      endAdornment: (
                                        <InputAdornment position="start">
                                          RSD
                                        </InputAdornment>
                                      ),
                                    }}
                                  />
                                </Col>
                              )}
                              <Col lg={4} md={12} xs={12} className="mb-4">
                                <InputField
                                  label={t(`${translateForm}.trailerTargetId`)}
                                  name="trailerTargetId"
                                  value={data.trailerTargetId}
                                  onChange={handleInputChange}
                                  error={errors}
                                  errorsHandler={setErrors}
                                  fullWidth
                                  size="small"
                                  required
                                />
                              </Col>
                              {/* <Col lg={4} md={12} xs={12} className="mb-4">
                                <InputField
                                  label={t(`${translateForm}.trailerPlayerId`)}
                                  name="trailerPlayerId"
                                  value={data.trailerPlayerId}
                                  onChange={handleInputChange}
                                  error={errors}
                                  errorsHandler={setErrors}
                                  fullWidth
                                  size="small"
                                  required
                                />
                              </Col> */}
                              <Col lg={4} md={12} xs={12} className="mb-4">
                                <InputField
                                  label={t(`${translateForm}.videoTargetId`)}
                                  name="videoTargetId"
                                  value={data.videoTargetId}
                                  onChange={handleInputChange}
                                  error={errors}
                                  errorsHandler={setErrors}
                                  fullWidth
                                  size="small"
                                  required
                                />
                              </Col>
                              <Col lg={4} md={12} xs={12} className="mb-4">
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      size="small"
                                      name="drm"
                                      checked={!!data?.drm}
                                      onChange={handleInputChange}
                                    />
                                  }
                                  label={"DRM zaštita videa?"}
                                />
                              </Col>
                              {/* <Col lg={4} md={12} xs={12} className="mb-4">
                                <InputField
                                  label={t(`${translateForm}.videoPlayerId`)}
                                  name="videoPlayerId"
                                  value={data.videoPlayerId}
                                  onChange={handleInputChange}
                                  error={errors}
                                  errorsHandler={setErrors}
                                  fullWidth
                                  size="small"
                                  required
                                />
                              </Col> */}
                              {data?.shoppable && (
                                <Col lg={4} md={12} xs={12} className="mb-4">
                                  <InputField
                                    label={t(`${translateForm}.accessDuration`)}
                                    name="accessDuration"
                                    value={data.accessDuration}
                                    onChange={handleInputChange}
                                    error={errors}
                                    errorsHandler={setErrors}
                                    fullWidth
                                    size="small"
                                    required={data?.shoppable}
                                  />
                                </Col>
                              )}
                              <Col lg={4} md={12} xs={12} className="mb-4">
                                <InputField
                                  label={t(`${translateForm}.position`)}
                                  name="position"
                                  value={data.position}
                                  error={errors}
                                  errorsHandler={setErrors}
                                  fullWidth
                                  size="small"
                                  onChange={(e) => {
                                    const value = e.target.value;

                                    // Dozvoli samo cifre i max 6 karaktera
                                    if (
                                      /^\d*$/.test(value) &&
                                      value.length <= 6
                                    ) {
                                      // Ako je vrednost veća od 0 — prosledi je
                                      if (Number(value) > 0 || value === "") {
                                        handleInputChange(e);
                                      }
                                    }
                                  }}
                                  inputProps={{
                                    inputMode: "numeric",
                                    pattern: "[0-9]*",
                                  }}
                                />
                              </Col>
                              <Col lg={4} md={12} xs={12} className="mb-4">
                                <FormControl fullWidth required>
                                  <InputLabel id="demo-simple-select-label">
                                    {t(`${translateForm}.sectionType`)}
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={data.sectionType}
                                    label={t(`${translateForm}.sectionType`)}
                                    name="sectionType"
                                    onChange={handleInputChange}
                                    size="small"
                                  >
                                    <MenuItem value="MICRO">MIKROKAT</MenuItem>
                                    <MenuItem value="MINI">MINIKAT</MenuItem>
                                    <MenuItem value="MASTER">
                                      MASTERKAT
                                    </MenuItem>
                                  </Select>
                                </FormControl>
                              </Col>
                              {data?.sectionType === "MASTER" && (
                                <Col lg={12}>
                                  <Row>
                                    <Col
                                      lg={4}
                                      md={12}
                                      xs={12}
                                      className="mb-4"
                                    >
                                      <Autocomplete
                                        options={channelFormList || []}
                                        getOptionLabel={(option) =>
                                          option?.name || ""
                                        }
                                        value={
                                          channelFormList?.find(
                                            (c) => c.id === data.channelId
                                          ) || null
                                        }
                                        onChange={(e, newValue) => {
                                          // ovde simuliramo event za kompatibilnost sa postojećim setChannelChange
                                          setChannelChange({
                                            target: {
                                              name: "channelId",
                                              value: newValue ? newValue.id : 0,
                                            },
                                          });
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            label={t(
                                              `${translateForm}.channelId`
                                            )}
                                            size="small"
                                            required={
                                              data?.sectionType === "MASTER"
                                            }
                                            error={!!errors.channelId}
                                            helperText={errors.channelId}
                                          />
                                        )}
                                      />
                                    </Col>
                                    <Col
                                      lg={4}
                                      md={12}
                                      xs={12}
                                      className="mb-4"
                                    >
                                      <Autocomplete
                                        options={courseFormList || []}
                                        getOptionLabel={(option) =>
                                          option?.name || ""
                                        }
                                        value={
                                          courseFormList?.find(
                                            (c) => c.id === data.courseId
                                          ) || null
                                        }
                                        onChange={(e, newValue) => {
                                          handleInputChange(
                                            "courseId",
                                            newValue ? newValue.id : 0
                                          );
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            label={t(
                                              `${translateForm}.courseId`
                                            )}
                                            size="small"
                                            required={
                                              data?.sectionType === "MASTER"
                                            }
                                            error={!!errors.courseId}
                                            helperText={errors.courseId}
                                          />
                                        )}
                                        disabled={!data.channelId}
                                      />
                                    </Col>
                                    <Col
                                      lg={4}
                                      md={12}
                                      xs={12}
                                      className="mb-4"
                                    >
                                      <InputField
                                        label={t(
                                          `${translateForm}.coursePosition`
                                        )}
                                        type="number"
                                        name="coursePosition"
                                        value={data.coursePosition}
                                        error={errors}
                                        errorsHandler={setErrors}
                                        fullWidth
                                        size="small"
                                        disabled={!data.channelId}
                                        required={
                                          data?.sectionType === "MASTER"
                                        }
                                        onChange={(e) => {
                                          const value = e.target.value;

                                          // Dozvoli samo cifre i max 6 karaktera
                                          if (
                                            /^\d*$/.test(value) &&
                                            value.length <= 6
                                          ) {
                                            // Ako je vrednost veća od 0 — prosledi je
                                            if (
                                              Number(value) > 0 ||
                                              value === ""
                                            ) {
                                              handleInputChange(e);
                                            }
                                          }
                                        }}
                                        inputProps={{
                                          inputMode: "numeric",
                                          pattern: "[0-9]*",
                                        }}
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                              )}
                              <Col lg={12}>
                                <Row>
                                  <Col lg={6} md={12} xs={12} className="mb-4">
                                    {!data.categories ? (
                                      <Skeleton
                                        variant="rectangular"
                                        width="100%"
                                        height={40}
                                      />
                                    ) : (
                                      <div className="position-relative">
                                        <TagAutocomplete
                                          options={categoryOptions}
                                          label="Kategorije *"
                                          value={data.categories}
                                          name="categories"
                                          required
                                          onChangeHandler={handleInputChange}
                                        />
                                        {errors?.categories && (
                                          <FormHelperText>
                                            obavezno polje
                                          </FormHelperText>
                                        )}
                                      </div>
                                    )}
                                  </Col>
                                  <Col lg={6} md={12} xs={12} className="mb-4">
                                    {!data.tags ? (
                                      <Skeleton
                                        variant="rectangular"
                                        width="100%"
                                        height={40}
                                      />
                                    ) : (
                                      <div className="position-relative">
                                        <TagAutocomplete
                                          options={tagOptions}
                                          label="Tagovi *"
                                          value={data.tags}
                                          name="tags"
                                          onChangeHandler={handleInputChange}
                                        />
                                        {errors?.tags && (
                                          <FormHelperText>
                                            obavezno polje
                                          </FormHelperText>
                                        )}
                                      </div>
                                    )}
                                  </Col>
                                  <Col lg={6} md={12} xs={12} className="mb-4">
                                    <Autocomplete
                                      options={channelFormList || []}
                                      getOptionLabel={(option) =>
                                        option?.name || ""
                                      }
                                      value={
                                        channelFormList?.find(
                                          (c) => c.id === data.channelLinkId
                                        ) || null
                                      }
                                      onChange={(e, newValue) => {
                                        // ovde simuliramo event za kompatibilnost sa postojećim setChannelChange
                                        handleSelectChange(
                                          "channelLinkId",
                                          newValue ? newValue.id : 0
                                        );
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label={t(
                                            `${translateForm}.channelLinkId`
                                          )}
                                          size="small"
                                          error={!!errors.channelLinkId}
                                          helperText={errors.channelLinkId}
                                        />
                                      )}
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg={12}>
                                <Card>
                                  <Card.Header>
                                    <SelectStatus
                                      discount={true}
                                      data={data}
                                      handleInputChange={handleInputChange}
                                    />
                                  </Card.Header>
                                  {data?.discount && (
                                    <Card.Body>
                                      <Row>
                                        <Col
                                          lg={4}
                                          md={12}
                                          xs={12}
                                          className="mb-4"
                                        >
                                          <AmountInputField
                                            label={t(
                                              `${translateForm}.discountPrice`
                                            )}
                                            name="discountPrice"
                                            value={data.discountPrice}
                                            onChange={handleInputChange}
                                            error={errors}
                                            errorsHandler={setErrors}
                                            fullWidth
                                            required={data?.discount}
                                            size="small"
                                            inputProps={{
                                              endAdornment: (
                                                <InputAdornment position="start">
                                                  RSD
                                                </InputAdornment>
                                              ),
                                            }}
                                          />
                                        </Col>
                                        <Col
                                          lg={4}
                                          md={12}
                                          xs={12}
                                          className="mb-4"
                                        >
                                          <InputField
                                            type="date"
                                            label={t(
                                              `${translateForm}.discountStart`
                                            )}
                                            name="discountStart"
                                            value={data?.discountStart}
                                            onChange={handleInputChange}
                                            error={errors}
                                            errorsHandler={setErrors}
                                            fullWidth
                                            required={data?.discount}
                                            size="small"
                                            inputLabelProps={{ shrink: true }}
                                            inputProps={{
                                              max:
                                                data?.discountEnd || undefined,
                                            }}
                                          />
                                        </Col>
                                        <Col
                                          lg={4}
                                          md={12}
                                          xs={12}
                                          className="mb-4"
                                        >
                                          <InputField
                                            type="date"
                                            label={t(
                                              `${translateForm}.discountEnd`
                                            )}
                                            name="discountEnd"
                                            value={data?.discountEnd}
                                            onChange={handleInputChange}
                                            error={errors}
                                            errorsHandler={setErrors}
                                            fullWidth
                                            size="small"
                                            inputLabelProps={{ shrink: true }}
                                            inputProps={{
                                              min:
                                                data?.discountStart ||
                                                undefined,
                                            }}
                                          />
                                        </Col>
                                      </Row>
                                    </Card.Body>
                                  )}
                                </Card>
                              </Col>
                            </Row>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col lg={12}>
                      <Card>
                        <Card.Header>
                          <FormTitleMain title="Prevodi" />
                        </Card.Header>
                        <Card.Body>
                          {/* Tabs header */}
                          <Tabs
                            value={activeLocaleTab}
                            onChange={handleChangeLocaleTab}
                            variant="scrollable"
                            // scrollButtons
                            // allowScrollButtonsMobile
                          >
                            {languagesItems.map((lng, idx) => (
                              <Tab
                                key={lng.code}
                                label={lng.label}
                                {...a11yProps(idx)}
                                // primer: pokaži zvezdicu ako fali naslov
                                iconPosition="end"
                              />
                            ))}
                          </Tabs>

                          {/* Tabs content */}
                          {languagesItems.map((lng, idx) => (
                            <TabPanel
                              key={lng.code}
                              value={activeLocaleTab}
                              index={idx}
                            >
                              <Row>
                                <Col lg={12} className="mb-4">
                                  <InputField
                                    name={`name_${lng.code}`}
                                    label={`${t(`${translateForm}.title`)} `}
                                    value={locales[lng.code].name}
                                    size="small"
                                    onChange={(e) =>
                                      updateLocale(
                                        lng.code,
                                        "name",
                                        e.target.value
                                      )
                                    }
                                    required
                                    error={errors?.locales?.[lng.code]?.name}
                                    errorsHandler={setErrors}
                                  />
                                </Col>

                                <Col lg={12} className="mb-3">
                                  <label className="form-label">
                                    {t(`${translateForm}.description`)}
                                    <span className="text-danger"> *</span>
                                  </label>
                                  <CKEditor
                                    editor={Editor}
                                    data={locales[lng.code].description || ""}
                                    onChange={(event, editor) => {
                                      const data = editor.getData();
                                      updateLocale(
                                        lng.code,
                                        "description",
                                        data
                                      );
                                    }}
                                    onReady={(editor) => {
                                      // opciono ako želiš da editor bude full width
                                      editor.editing.view.change((writer) => {
                                        writer.setStyle(
                                          "min-height",
                                          "250px",
                                          editor.editing.view.document.getRoot()
                                        );
                                      });
                                    }}
                                  />
                                  {errors?.locales?.[lng.code]?.description && (
                                    <div className="text-danger mt-1">
                                      {errors.locales[lng.code].description}
                                    </div>
                                  )}
                                </Col>
                              </Row>
                            </TabPanel>
                          ))}
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Col>
                <Col lg={3}>
                  <Row>
                    <Col lg={12}>
                      <Card>
                        <Card.Header>{t(`global.settings`)}</Card.Header>
                        <Card.Body>
                          <SelectStatus
                            active={true}
                            data={data}
                            handleInputChange={handleInputChange}
                          />
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col lg={12}>
                      <Card>
                        <Card.Header>Slika</Card.Header>
                        <Card.Body>
                          <div className="image-info-detail">
                            <span>
                              <b>Dimenzija slike:</b> 240 x 315 px
                            </span>
                            <br />
                            <span>
                              <b>Format slike:</b> .jpg, .png, .jpeg, .gif,
                              .svg, .webp
                            </span>
                            <br />
                            <span>
                              <b>Veličina fajla:</b> 500 KB (preporučeno)
                            </span>
                          </div>
                          <UploadImage
                            name="image"
                            label="Odaberite sliku"
                            value={files.image}
                            onChange={setFile("image")}
                            required
                          />
                        </Card.Body>
                      </Card>
                    </Col>
                    {/* <Col lg={12}>
                      <Card>
                        <Card.Header>Mobilna slika</Card.Header>
                        <Card.Body>
                          <UploadImage
                            name="smallImage"
                            label="Odaberite sliku"
                            value={files.smallImage}
                            onChange={setFile("smallImage")}
                            required
                          />
                        </Card.Body>
                      </Card>
                    </Col> */}
                  </Row>
                </Col>
              </Row>
            </form>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default VideoAdd;
